export class StorageService {
  private storage: Storage | undefined;

  constructor(storage: Storage | undefined) {
    this.storage = storage;
  }

  read(key: string): string | null {
    try {
      return this.storage?.getItem(key) ?? null;
    } catch {
      return null;
    }
  }

  write(key: string, value: string): void {
    try {
      this.storage?.setItem(key, value);
    } catch {
      // storage unavailable / write blocked
    }
  }

  remove(key: string): void {
    try {
      this.storage?.removeItem(key);
    } catch {
      // storage unavailable
    }
  }

  clear(): void {
    try {
      this.storage?.clear();
    } catch {
      // storage unavailable
    }
  }
}
